









import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class LoadingPanel extends Vue {
  @Prop(Boolean)
  readonly isLoading!: boolean;
}
